import React from 'react';
import { Box, Paper } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import chatbotIcon from 'assets/images/chatbot-icon.png';
import PropTypes from 'prop-types';
import { theme } from 'utils/theme';
import TypingIndicator from './TypingIndicator';

const ChatMessages = ({ messages, isLoading, endRef }) => (
  <Box sx={{ flexGrow: 1, p: 2, overflowY: 'auto', backgroundColor: theme.palette.grey[100] }}>
    {messages.map((message, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          justifyContent: message.role === 'user' ? 'flex-end' : 'flex-start',
          marginBottom: '16px'
        }}>
        {message.role === 'assistant' && (
          <img src={chatbotIcon} alt="Chatbot" style={{ width: 24, height: 24, marginRight: 5 }} />
        )}
        <Paper
          elevation={1}
          sx={{
            padding: '10px',
            maxWidth: '75%',
            overflowWrap: 'break-word',
            bgcolor: message.role === 'user' && theme.palette.primary.main,
            color: message.role === 'user' ? theme.palette.primary.contrastText : theme.palette.text.primary,
            borderRadius: message.role === 'user' ? '20px 20px 4px 20px' : '20px 20px 20px 4px',
          }}
        >
          <ReactMarkdown>{message.content}</ReactMarkdown>
        </Paper>
      </Box>
    ))}

    {isLoading && (
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <img src={chatbotIcon} alt="Chatbot" style={{ width: 24, height: 24, marginRight: '10px' }} />
        <Paper elevation={1} sx={{ padding: '10px' }}>
          <TypingIndicator />
        </Paper>
      </Box>
    )}
    <div ref={endRef} />
  </Box>
);

ChatMessages.propTypes = {
  messages: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  endRef: PropTypes.object
};

export default ChatMessages;
